<template>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="18px" height="18px" viewBox="0 0 992 992" fill="#fff" xml:space="preserve"><g><circle cx="144.3" cy="496" r="144.3"/><circle cx="496" cy="496" r="144.3"/><circle cx="847.7" cy="496" r="144.3"/></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
</template>

<script>
export default {
    name: 'menuBtn'
}
</script>